import { useState } from 'react';

export const useNavigation = () => {
  const [isVisible, setIsVisible] = useState(false);

  const onToggleNavigation = () => setIsVisible(isVisible => !isVisible);

  return {
    isVisible,
    onToggleNavigation,
  };
};
